import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet's default marker icon issue with CRA/Webpack
// Webpack changes asset paths, so we need to manually set the icon URLs
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
